<p-dropdown
  [options]="data()"
  optionLabel="name"
  [placeholder]="placeholder()"
  (onChange)="onCityChange($event.value)"
  class="custome-dropdown"
  [(ngModel)]="selectedValue"
/>
